import { COLORS } from '@/styles/color';
import { FONT_WEIGHTS } from '@/styles/typography';
import styled from 'styled-components';

const ANIMATION_SPEED = '0.15s';

interface ButtonProps {
  fullWidth?: boolean;
}

const PrimaryDefaultButton = styled.button<ButtonProps>`
  /* Remove all default browser appearance */
  appearance: none;

  background-color: var(--button-color, ${COLORS.VIOLET.BASE});
  color: var(--button-text-color, ${COLORS.VIOLET.XTRALIGHT});

  border: 1px solid var(--button-border-color, transparent);
  border-radius: 9999px;

  margin: 0;
  padding: 13px 24px;

  font-size: 16px;
  font-weight: ${FONT_WEIGHTS.BOLD};
  text-align: center;

  width: ${(props) => (props.fullWidth ? '100%' : 'auto')};
  min-width: 132px;

  cursor: pointer;
  display: inline-block;

  transition: background-color var(--button-animation-speed, ${ANIMATION_SPEED}) ease-in-out,
    color var(--button-animation-speed, ${ANIMATION_SPEED}) ease-in-out,
    border-color var(--button-animation-speed, ${ANIMATION_SPEED}) ease-in-out,
    box-shadow var(--button-animation-speed, ${ANIMATION_SPEED}) ease-in-out;

  &:hover {
    background-color: var(--button-color-hover, ${COLORS.VIOLET.LOWLIGHT});
    color: var(--button-text-color-hover, ${COLORS.VIOLET.XTRALIGHT});
    border-color: var(--button-border-color-hover, transparent);
  }

  &:disabled {
    opacity: 0.25;
    cursor: not-allowed;
  }
`;

export default PrimaryDefaultButton;
